import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function VideoPlayer({
  id,
  src,
  item,
  height,
  width,
  size = 100,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState();
  return (
    <>
      <div
        className={`w-[${size}px] h-[${size}px] overflow-hidden flex justify-center items-center`}
      >
        <video
          ref={item}
          height={height || 80}
          width={width || 100}
          id={id}
          src={src}
          playsInline
          onClick={(e) => {
            setIsOpen(true);
            setVideoSrc(e.target?.currentSrc);
          }}
          className="w-full h-full object-cover aspect-square cursor-zoom-in"
        ></video>
      </div>

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex justify-center items-center">
          <div className="bg-white rounded-lg shadow-lg z-50 max-w-screen-lg w-full p-2 m-4">
            <div className="relative w-full">
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-2 right-2 text-gray-700 text-xl z-50 bg-white rounded-full p-0.5 px-2 hover:bg-gray-100"
                aria-label="Close"
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
              <video
                autoPlay
                controls
                src={videoSrc}
                className="w-full h-auto max-h-[80vh] rounded shadow-lg"
                playsInline
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
